module.exports = __webpack_public_path__ + "static/img/young_emissary2.ecea20f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/young_emissary2.png
// module id = 3kx8
// module chunks = 0